// extracted by mini-css-extract-plugin
module.exports = {"competitiveAccounts":"CompetitiveAccounts__competitiveAccounts__MHIUD","competitiveAccountsSummary":"CompetitiveAccounts__competitiveAccountsSummary__nv4he"};